// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.verify-user-email-wrapper{font-size:12px;margin-top:4px;line-height:21px}.verify-user-email-wrapper span{color:var(--warning-color);text-decoration:underline;font-weight:500}.verify-email-modal{text-align:center;width:376px}.verify-email-modal p{margin-bottom:12px}.verify-email-modal span{color:var(--gray-6);font-weight:500}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
